module.exports = __webpack_public_path__ + "static/media/IO.aecf8a97.svg";